import React from 'react';

/**
 * Assegnando questo simbolo ad un componente React, è possibile
 * identificare se un elemento è un RadioGroupElement.
 * Vale anche per i CheckboxGroupElement.
 * In questo modo è possibile gestire l'accessibilità in modo
 * differente, es. per i RadioGroup è necessario associare la label
 * all'elemento tramite `aria-labelledby` e non tramite `for`.
 */
export const IsRadioOrCheckboxGroupElementSymbol =
  '__IsRadioOrCheckboxGroupElement';

/**
 * Verifica se l'elemento passato è un RadioGroupElement.
 */
export function isRadioOrCheckboxGroupElement(element: React.ReactNode) {
  return (
    React.isValidElement(element) &&
    typeof element.type !== 'string' &&
    IsRadioOrCheckboxGroupElementSymbol in element.type &&
    element.type?.[IsRadioOrCheckboxGroupElementSymbol] === true
  );
}
